import React from "react";

type Props = {
    fallback: (error: Error) => React.ReactNode;
    children: React.ReactNode;
}

type State = {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundaryRapper extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    
    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: unknown) {
        console.error("ErrorBoundary caught an error", error, info);
    }

    render() {
        if (this.state.hasError && this.state.error) {
            return this.props.fallback(this.state.error);
        }
    
        return this.props.children;
    }
}